import React from 'react';
import './css/theme.css';
import './App.css';
import { UserProvider } from './firebase_service/UserContext';
import AppRouter from './AppRouter';
import { ToastProvider } from './jsx/components/ToastProvider';
import LightingBackground from './jsx/components/LightingBackground.jsx';
 import { GoogleOAuthProvider } from '@react-oauth/google';
// Import Google Fonts
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';

                 
function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID} > 
    <UserProvider>
      <ToastProvider>
        <LightingBackground />
        <AppRouter />
      </ToastProvider>
    </UserProvider>
    </GoogleOAuthProvider> // Removed
  );
}

export default App;
